function addNostoCarousel(divId) {
  const container = document.getElementById(divId);
  let useParent = container.parentElement?.tagName?.toLowerCase() === 'cart-drawer-items';
  const parentId = divId
  const elements = container.querySelectorAll(".nosto-carousel > div");
  for (const element of elements) {
    new Card(element.dataset.productId, element.id, "carousel", container.dataset.nostoSlotId, useParent, parentId);
  }
  if (container.parentElement.querySelector(".carousel-title")) {
    container.querySelector(".title").remove();
  }
  container.classList.remove("hidden");
}

window.initializeNostoCarrusel = function initializeNostoCarrusel(slotId) {
  const root = document.querySelector(`[data-nosto-slot="${slotId}"]`);
  if (!root) return;

  if (root.dataset.nostoBound === "1") return;
  root.dataset.nostoBound = "1";

  root.addEventListener("click", (e) => {
    const sizeEl = e.target.closest(".size[data-nosto-variant-ids]");
    if (!sizeEl || !root.contains(sizeEl)) return;

    const productId = sizeEl.getAttribute("data-nosto-product-id");
    const attributionKey = sizeEl.getAttribute("data-nosto-attribution-key");
    const idsStr = sizeEl.getAttribute("data-nosto-variant-ids") || "";

    const ids = idsStr.split(",").map(s => s.trim()).filter(Boolean);

    if (!ids.length) return;

    const variantId = ids[0];

    if (cart?.add) {
      cart.add(variantId, productId, attributionKey);
    }
  });
};

//Inicializa el add to cart
(function watchNostoSlots() {
  const bindAll = () => {
    document.querySelectorAll("[data-nosto-slot]").forEach((el) => {
      const slotId = el.getAttribute("data-nosto-slot");
      window.initializeNostoCarrusel?.(slotId);
    });
  };

  bindAll();

  const obs = new MutationObserver(() => bindAll());
  obs.observe(document.documentElement, { childList: true, subtree: true });
})();

function bindNostoSizeAddOnce() {
  if (window.__nostoSizeClickBound) return;
  window.__nostoSizeClickBound = true;

  document.addEventListener("click", (e) => {
    const sizeEl = e.target.closest(".size[data-nosto-variant-ids]");
    if (!sizeEl) return;

    const productId = sizeEl.getAttribute("data-nosto-product-id");
    const attributionKey = sizeEl.getAttribute("data-nosto-attribution-key");
    const idsStr = sizeEl.getAttribute("data-nosto-variant-ids") || "";
    const ids = idsStr.split(",").map((s) => s.trim()).filter(Boolean);
    if (!ids.length) return;

    const variantId = ids[0];

    e.preventDefault();
    e.stopPropagation();

    if (cart?.add) {
      cart.add(variantId, productId, attributionKey);
    }
  });
}
